import PriceOverviewItemList, { PriceOverviewItemListProps } from './PriceOverviewItemList';

export type { PriceOverviewItemListProps };
export default PriceOverviewItemList;
